import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class VatRateHasAlreadyChangedOnItemError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.items.vat-rate.vat-rate-has-already-changed-on-item');
    }
}
